/* template */
<template><div class="union-card-container"><div class="union-card-container-header"><div class="union-card-container-header-left"><div class="union-logotype"><mpx-image src="https://ut-static.udache.com/webx/sfc/5jewOiQAoTmZ7i5nVfKvo.png" class="union-logotype-icon"/><span>中转</span></div><div class="union-station"><span>{{ orderItem.from_station_name }}</span><mpx-image src="https://ut-static.udache.com/webx/sfc/viT-malXsrWwYdW2RR_5O.png" class="train-station-icon"/><span>{{ orderItem.to_station_name }}</span></div></div><div :style='[("color:"+(orderItem.status_color))] | transRpxStyle' class="union-card-container-header-right">{{ orderItem.status_name }}</div></div><es-card-del :index="(orderIndex)" :item="({ orderItem, index: orderIndex, titleItem })" @click-left="goDetail" @click-right="delData"><div slot="mainContext" class="main-context"><train-card v-for="(item, index) in (rafactorOrderList)" :cardIndex="(index + 1)" :item="(item)" @tap="goDetail(orderItem)"/></div><div slot="delContext" class="del-box"><div>删除</div></div></es-card-del></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m50e2b4f0"}'>
.union-card-container
  display flex
  flex-direction column
  border-radius 8px
  background #fdf6f1
  &-header
    display flex
    padding 10px 15px 10px 12.5px
    justify-content space-between
    align-items center
    &-left
      display flex
      .union-logotype
        padding 3px 6px
        border-radius 4px
        font-family PingFangSC-Medium
        font-size 12px
        font-weight 500
        line-height 12px
        text-align center
        color #FFFFFF
        background #FF6400
        margin-right 8px
        &-icon
          height 11px
          width 11px
          margin-right 2px
      .union-station
        font-family PingFangSC-Medium
        font-size 14px
        font-weight 500
        line-height 16px
        color #222
        display flex
        align-items center
        .train-station-icon
          height 3px
          width 10.5px
          margin 0 2px
    &-right
      font-family PingFangSC-Medium
      font-size 14px
      font-weight 500
      line-height 17px
      color #666
  .del-box
    display flex
    justify-content flex-end
    align-items center
    border-radius 9px
    font-size 14px
    font-weight 500
    font-family PingFangSC-Regular
    height 100%
    background #F93822
    padding-right 24px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m50e2b4f0"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./transfer-train-order-card.mpx.js?isComponent&outputPath=components%2Ftransfer-train-order-card50e2b4f0%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./transfer-train-order-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Ftransfer-train-order-card50e2b4f0%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m50e2b4f0"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/transfer-train-order-card50e2b4f0/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'train-card':getComponent(require("./newTrainOrderCard.mpx?isComponent&outputPath=components%2FnewTrainOrderCardb25b7030%2Findex")),'es-card-del':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/card-del/index.mpx?isComponent&outputPath=components%2Findex1fb7d810%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
